import React from 'react';
import Layout from './components/layout/layout'

function App() {
  return (
    <Layout>
      <h2>Some page content</h2>
      <h2>Some page content</h2>
      <h2>Some page content</h2>
    </Layout>
  );
}

export default App;
